export const environment = {
  production: false,
  apiEndpoint: 'https://api-pbcheckinclass-staging.qivos.net/sso/v1'
};
